
export interface IVIPCertificateContact {
	civility?: string;
	last_name?: string;
	first_name?: string;
	service?: string;
	company?: string;
	email?: string;
}

export function createCertificateContact(): IVIPCertificateContact {
	return {
		civility: "",
		last_name: "",
		first_name: "",
		service: "",
		company: "",
		email: "",
	};
}

export function checkCertificateContact(data: IVIPCertificateContact) {
	if (data.civility === undefined) {
		data.civility = "";
	}
	if (data.last_name === undefined) {
		data.last_name = "";
	}
	if (data.first_name === undefined) {
		data.first_name = "";
	}
	if (data.service === undefined) {
		data.service = "";
	}
	if (data.company === undefined) {
		data.company = "";
	}
	if (data.email === undefined) {
		data.email = "";
	}
}
